import { connect } from 'react-redux'

import {
    getCollaborativeIndexationCreationField,
} from '../../../../../../redux/collaborativeIndexations/selectors'
import DateCalendar from './DateCalendar.jsx'
import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationGregorianDate,
    updateCollaborativeIndexationRepublicanDate,
} from '../../../../../../redux/collaborativeIndexations/actions'

const mapStateToProps = (state, ownProps) => ({
    field: getCollaborativeIndexationCreationField(state, ownProps.fieldName)
})

const mapDispatchToProps = (dispatch, getState) => ({
    updateGregorianDate: (field, value) => dispatch(updateCollaborativeIndexationGregorianDate(field, value)),
    updateRepublicanDate: (field, value) => dispatch(updateCollaborativeIndexationRepublicanDate(field, value)),
    resetInvalidField: (field) => dispatch(resetCollaborativeIndexationCreationInvalidField(field)),
})

export const DateCalendarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DateCalendar)
